import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { generateQuestion } from './GptQuestionGenerateApi';
import { IQuestionDetailAnswer, TQuestionDifficulty } from '../QuestionSlice';

export interface IGeneratedQuestion {
  _id?: string;
  details: string;
  answers: Array<IQuestionDetailAnswer>;
  markingSchema: string;
  difficulty: TQuestionDifficulty;
  marks: number;
  theoryQuestion: string;
}
export interface IGptQuestionGenerateState {
  status: 'idle' | 'loading' | 'rejected';
  questions?: Array<IGeneratedQuestion>;
  threadId?: string;
}

const initialState: IGptQuestionGenerateState = {
  status: 'idle',
  questions: undefined,
  threadId: undefined,
};

export const GptQuestionSlice = createSlice({
  name: 'gptQuestionGenerate',
  initialState,
  reducers: {
    reset: (state) => {
      state.status = 'idle';
      state.questions = undefined;
      state.threadId = undefined;
    },
    addQuestion: (state, action) => {
      if (!state.questions) {
        state.questions = [];
      }
      state.questions.push(action.payload);
    },
    setThreadId: (state, action) => {
      state.threadId = action.payload;
    },
    setStreamingStatus: (state, action) => {
      state.status = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateQuestion.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(generateQuestion.fulfilled, (state, action) => {
        state.status = 'idle';
        // Handle both single question (string) and multiple questions (array)
        if (Array.isArray(action.payload.questions)) {
          state.questions = action.payload.questions;
        } else {
          // If it's a single question, convert to array for consistency
          state.questions = action.payload.questions
            ? [action.payload.questions]
            : undefined;
        }
        if (action.payload.threadId) {
          state.threadId = action.payload.threadId;
        } else {
          state.threadId = undefined;
        }
      })
      .addCase(generateQuestion.rejected, (state) => {
        state.status = 'rejected';
      });
  },
});

export const getGptQuestionGenerateState = (
  state: RootState
): RootState['gptQuestionGenerate'] => state.gptQuestionGenerate;

export const {
  reset,
  addQuestion,
  setThreadId,
  setStreamingStatus,
} = GptQuestionSlice.actions;

export * from './GptQuestionGenerateApi';
export default GptQuestionSlice.reducer;
